function isHandlerKind(kind) {
  return (input) => {
    return input != null && typeof input === "object" && "__kind" in input && input.__kind === kind;
  };
}
export {
  isHandlerKind
};
//# sourceMappingURL=isHandlerKind.mjs.map